module.exports = __webpack_public_path__ + "img/windF.30fc2782.png";